import React from 'react'
import { t } from '../i18n'
import { useCategories } from '../State/refData'
import ChipRow from './ChipRow'
import { ClockIcon, FlameIcon } from './Icons'

export const VIEW_TOP = 'sve'
export const VIEW_NEW = 'najnovije'

/* Početna: "Najčitanije" (the default feed, "Sve") | "Najnovije" | categories
   (spec 5.1). The icon of the selected view is orange, otherwise grey. */
export default function CategoryChips({ value, onSelect }) {
  const categories = useCategories()
  const chip = (key, label, icon = null) => (
    <button
      key={key}
      type="button"
      className={`chip ${value === key ? 'chip-active' : ''}`}
      aria-pressed={value === key}
      onClick={() => onSelect(key)}
    >
      {icon}
      <span>{label}</span>
    </button>
  )
  return (
    <ChipRow label={t('chips.label')} activeKey={value} className="category-chips">
      {chip(
        VIEW_TOP,
        t('chips.mostRead'),
        <FlameIcon size={15} className={`chip-icon ${value === VIEW_TOP ? 'on' : ''}`} />
      )}
      {chip(
        VIEW_NEW,
        t('chips.newest'),
        <ClockIcon size={15} className={`chip-icon ${value === VIEW_NEW ? 'on' : ''}`} />
      )}
      <span className="chip-divider" aria-hidden="true" />
      {categories.map((c) => chip(c.slug, c.title))}
    </ChipRow>
  )
}
